import React from 'react';
import './PricingOptions.scss';
import { Button } from '@mui/material';
export default function PricingOptionsProd(props){
    return (

        <section class="plans__container">
            <div class="plans">
                <div class="plansHero">
                    <h1 class="plansHero__title">Simple, transparent pricing</h1>
                    <p class="plansHero__subtitle">No contracts. No suprise fees.</p>
                </div>
                <div class="planItem__container">

                    <div class="planItem planItem--free">

                        <div class="card">
                            <div class="card__header">
                                <div class="card__icon symbol symbol--rounded"></div>
                                <h2>Free </h2>
                            </div>
                            <div class="card__desc"></div>
                        </div>

                        <div class="price">$0<span>/ month</span></div>

                        <ul class="featureList">
                            
                            <li>Store limited number (i.e. up to 20) of receipts</li>
                            <li>1 user</li>
                            <li class="disabled">Export records to spreadsheet</li>
                            <li class="disabled">Expense claims management</li>
                            <li class="disabled">Unlimited users</li>
                            <li class="disabled">Advanced analytics</li>
                            <li class="disabled">Personalised support</li>
                        </ul>

                        
                    </div>

                    <div class="planItem planItem--pro">
                        <div class="card">
                            <div class="card__header">
                                <div class="card__icon symbol"></div>
                                <h2>Advantage</h2>
                                <div class="card__label label">Best Value</div>
                            </div>
                            <div class="card__desc">Free trial 120 days</div>
                        </div>

                        <div class="price">$9.99 <span>/ month</span></div>

                        <ul class="featureList">
                            
                            <li>Store up to 2000 receipts</li>
                            <li>Up to 3 users</li>
                            <li>Export records to spreadsheet</li>
                            <li>Expense claims management</li>
                            <li class="disabled">Up to 7 users</li>
                            <li class="disabled">Personalised support</li>
                        </ul>

                        <button className="button button--pink" onClick={()=>{props.handleSubmit("prod_Qq40oyQ6AYBGLx");}}>Get Started</button>
                    </div>

                    <div class="planItem planItem--entp">
                        <div class="card">
                            <div class="card__header">
                                <div class="card__icon"></div>
                                <h2>Effective</h2>
                            </div>
                            <div class="card__desc">Free trial 120 days</div>
                        </div>

                        <div class="price">$19.99/month</div>

                        <ul class="featureList">
                            
                            <li>Store up to 2000 receipts</li>
                            <li>Export records to spreadsheet</li>
                            <li>Expense claims management</li>
                            <li>Up to 5 users</li>
                            <li>Personalised support</li>
                        </ul>
                        <button variant="contained" className="button button--white" onClick={()=>{props.handleSubmit("prod_Qq42WgoqxB0XGn")}}>Get Started</button>
                        
                    </div>
                </div>
            </div>
            <div style={{align:'center', paddingTop:'40px',fontSize:'12px'}}>
                * The privacy, legal disclaimer and terms of services are available on www.effiez.com.au. Effiez is not liable for loss of any of your receipts stored on Effiez. 
                *The plans will run and remain valid for 13 months effective from July 2024. All the prices may be reviewed and subject to change in future.</div>
        </section>
    )
}